import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: `${theme.spacing(1.2)} ${theme.spacing(2.4)} ${theme.spacing(
      1.2,
    )} ${theme.spacing(2.4)}`,
  },

  link: {
    color: '#005aa3',
    cursor: 'pointer',
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: 14,
    marginRight: theme.spacing(2.4),
  },

  linkBox: {
    padding: `${theme.spacing(1.2)} 0 0 ${theme.spacing(1.2)}`,
  },
})
